import axios from 'axios';
import { authURL } from '../api';

export const register = async (
  name,
  surname,
  email,
  phoneNumber,
  password,
  company,
  job,
  license
) => {
  const { data } = await axios.post(`${authURL}/signup`, {
    name,
    surname,
    email,
    phoneNumber,
    password,
    company,
    job,
    license
  });
  return data;
};

export const login = async (email, password) => {
  const { data } = await axios.post(`${authURL}/singin`, {
    email,
    password,
  });
  if (data.accessToken) {
    localStorage.setItem('user', JSON.stringify(data));
  }
  return data;
};

export const logout = () => {
  localStorage.removeItem('user');
};

export const forgotPassword = async (email) => {
  const response = await axios.post(`${authURL}/forgotpassword`, {
    email,
  });
  return response.data;
};

export const resetPassword = async (password, resetPasswordToken) => {
  const response = await axios.post(`${authURL}/resetpassword`, {
    password,
    resetPasswordToken,
  });
  return response.data;
};

export const verifyEmail = async (verifyEmailToken) => {
  const response = await axios.post(`${authURL}/verifyemail`, {
    verifyEmailToken,
  });
  return response.data;
};
